import * as types from "../../actions/systemlevel/index";
export default function(state = [], action) {
  switch (action.type) {
    case types.FETCH_PAYROLL_DEDUCTION_LIST:
      return action.payload.data;
    default:
      return state;
  }
}
